export enum Layout {
    Default = 'default',
    Chat = 'chat',
    Blank = 'blank',
    Loading = 'loading',
    TwoColumn = 'two-columns',
    FullWidth = 'full-width',
    DailyChatProduct = 'daily-chat/product',
}
